import { render, staticRenderFns } from "./CloseTab.vue?vue&type=template&id=2fe33679&scoped=true"
import script from "./CloseTab.vue?vue&type=script&lang=js"
export * from "./CloseTab.vue?vue&type=script&lang=js"
import style0 from "./CloseTab.vue?vue&type=style&index=0&id=2fe33679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe33679",
  null
  
)

export default component.exports